import Script from "next/script";

export default function ONE_SIGNAL() {
  return (
    <>
      <Script
        src="https://cdn.onesignal.com/sdks/OneSignalSDK.js"
        async={true}
        strategy="afterInteractive"
        defer
      ></Script>
    </>
  );
}
